// src/services/userService.js

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const createUser = async (userData) => {
  try {
    const response = await fetch(`${API_URL}/externals/create-member`, {
      method: "POST",
      body: userData,
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }
    const result = await response.json();

    return result;
  } catch (error) {
    console.error("Error submitting user request:", error);
    throw error;
  }
};

export const checkUserExists = async (email) => {
  try {
    const response = await fetch(`${API_URL}/externals/check-exists`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ email }),
    });
    console.log("Response:", response);
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const result = await response.json();

    return result;
  } catch (error) {
    console.error("Failed to check if user exists:", error);
    return false; // Assume user does not exist if there's an error
  }
};

export const connectUserToTier = async (userId, tierName) => {
  try {
    const response = await fetch(`${API_URL}/externals/${userId}/update-tier`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ tierName }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();

    if (result === "success") return { ok: true }; // Expected to return some status or updated data
  } catch (error) {
    console.error("Failed to connect user to tier:", error);
    throw error; // Re-throw to handle it according to your needs
  }
};

export const checkWaitList = async () => {
  try {
    const response = await fetch(`${API_URL}/externals/check-waitlist`, {
      method: "GET",
    });
    if (!response.ok) {
      throw new Error("Failed to fetch waitlist count");
    }
    const waitListCount = await response.json();
    return waitListCount; // Assuming the API returns an object with a 'count' property
  } catch (error) {
    console.error("Error fetching waitlist count:", error);
    return 0; // Default to 0 in case of an error
  }
};
